export default "__VITE_ASSET__JC7dq9X$__"